import React from 'react'

import { Icon, Text } from 'components/dataDisplay'
import { RoundButton, buttonMessages } from 'components/inputs'
import { Href } from 'components/navigation'


const ViewMoreButton: React.FC<{ to: string }> = ({ to }) => {
  return (
    <div className="flex flex-col items-center justify-center px-24">
      <Href className="text-center" to={to}>
        <RoundButton className="bg-black-100" title={buttonMessages.viewAll} size={32}>
          <Icon name="32/arrow-right" color="white" />
        </RoundButton>
        <Text className="mt-16 whitespace-nowrap" message={buttonMessages.viewAll} style="t4" />
      </Href>
    </div>
  )
}

export default ViewMoreButton
